export const displayErrors = (form: HTMLFormElement, errors: { [key: string]: string[] }) => {
  let errorContainer = form.querySelector(".validation-summary-errors");
  if (!errorContainer) {
    errorContainer = document.createElement("div");
    errorContainer.className = "validation-summary-errors";
    form.prepend(errorContainer);
  }

  errorContainer.innerHTML = ""; // Clear any existing errors
  const errorList = document.createElement("ul");

  Object.keys(errors).forEach((key) => {
    errors[key].forEach((message) => {
      const listItem = document.createElement("li");
      listItem.textContent = message;
      errorList.appendChild(listItem);
    });
  });

  errorContainer.appendChild(errorList);
};

export const clearErrors = (form: HTMLFormElement) => {
  const errorContainer = form.querySelector(".validation-summary-errors");
  if (errorContainer) errorContainer.innerHTML = "";
};
